<div class="login-container">
  <div class="d-flex flex-column align-items-center">
    <div class="d-flex align-items-center mt-4">
      <img src="/assets/login-satsang-logo.svg" />
      <span class="satsang-text ms-2">Satsang Communications</span>
    </div>

    <div class="login-card d-flex flex-column mt-5">
      <span class="satsang-text">Fill details below to Sign Up</span>
      <form [formGroup]="signupForm" (ngSubmit)="signup()">
        <div class="d-flex flex-column login-field-gap">
          <input type="text" class="login-field" placeholder="First Name" formControlName="firstName" />
          <span class="text-danger"
            *ngIf="signupForm.controls['firstName'].invalid && signupForm.controls['firstName'].touched">
            Please provide first name
          </span>
        </div>

        <div class="d-flex flex-column login-field-gap">
          <input type="text" class="login-field" placeholder="Last Name" formControlName="lastName" />
          <span class="text-danger"
            *ngIf="signupForm.controls['lastName'].invalid && signupForm.controls['lastName'].touched">
            Please provide last name
          </span>
        </div>
        <div class="d-flex flex-column login-field-gap">
          <input type="email" class="login-field" placeholder="Email ID" formControlName="email" />
          <span class="text-danger"
            *ngIf="signupForm.controls['email'].invalid && signupForm.controls['email'].touched">
            Please provide a valid email address
          </span>
        </div>

        <div class="d-flex flex-column login-field-gap">
          <input type="text" class="login-field" placeholder="+91 - Phone Number" formControlName="phoneNo"
            maxlength="10" />
          <span class="text-danger"
            *ngIf="signupForm.controls['phoneNo'].invalid && signupForm.controls['phoneNo'].touched">
            Please provide a valid phone no
          </span>
        </div>
        <div class="d-flex flex-column login-field-gap">
          <input type="password" class="login-field" placeholder="Create Password" formControlName="password" />
          <span class="text-danger"
            *ngIf="signupForm.controls['password'].invalid && signupForm.controls['password'].touched">
            Password should be at least 8 characters: contains uppercase, lowercase, numbers and special characters
          </span>
        </div>
        <div class="d-flex flex-column login-field-gap">
          <input type="password" class="login-field" placeholder="Confirm Password" />
          <!-- <span class="text-danger"
            *ngIf="signupForm.controls['confirmPassword'].invalid && signupForm.controls['confirmPassword'].touched">
            Password should be at least 8 characters: contains uppercase, lowercase, numbers and special characters
          </span> -->
          <!-- <span class="text-danger"
            *ngIf="signupForm.controls['confirmPassword'].valid && signupForm.value.password !== signupForm.value.confirmPassword">
            Password and confirmation password didn't match
          </span> -->
        </div>
        <button type="submit" class="btn-signup">
          Sign Up <img src="/assets/arrow-right-bold.svg" class="ms-1" />
        </button>
      </form>
    </div>

    <div class="d-flex my-5">
      <span class="account-text">Already have an Account?</span>
      <span class="login-text" routerLink="/login"> Log In</span>
    </div>
  </div>
</div>